export default __webpack_public_path__ + "static/media/empty-recruit.3c5e6999.png";